import { render, staticRenderFns } from "./DailyLessonsBtn.vue?vue&type=template&id=0420b75a"
import script from "./DailyLessonsBtn.vue?vue&type=script&lang=js"
export * from "./DailyLessonsBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports